import { mergeMap } from 'rxjs/operators';
import { of, from } from 'rxjs';

import { processEntities } from '../entities/entities.bulkload';
import { bulkLoadSuccess } from '../bulkload/bulkload.actions';
import * as OrderApi from './orders.api';

export const bulkLoadFulfillmentPlansFromScan$ = (fulfillmentPlanIds) => {
  return from(OrderApi.getByFulfillmentPlanIds(fulfillmentPlanIds)).pipe(
    mergeMap((response) => {
      const entities = processEntities(response);

      return of(bulkLoadSuccess(entities));
    }),
  );
};
